import { render, staticRenderFns } from "./AsyncCreator.vue?vue&type=template&id=48e6bc0a&scoped=true"
import script from "./AsyncCreator.vue?vue&type=script&lang=js"
export * from "./AsyncCreator.vue?vue&type=script&lang=js"
import style0 from "./AsyncCreator.vue?vue&type=style&index=0&id=48e6bc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6bc0a",
  null
  
)

export default component.exports